module.exports = __webpack_public_path__ + "19344183bc137a29287752ee6031bf78.svg";